<template>
    <b-row v-if="(row.status === '0' || row.status === '5')" >
        <div v-if="(row.checked === '1' || row.checked === 1  || row.checked === true ||row.checked === 'true')" class="OTloading">
            <div @click="checkItem" class="ot-icon-checkbox_selected" style="margin:1rem"></div>
        </div>
        <div v-else-if="(row.checked === '0' || row.checked === 0 || row.checked === false ||row.checked === 'false')" class="OTloading">
            <div @click="checkItem" class="ot-icon-checkbox" style="margin:1rem"></div>
        </div>
        <div v-else class="OTloading">
        </div>
    </b-row>
    <b-row v-else>
        <div v-if="(row.checked === '1' || row.checked === 1  || row.checked === true ||row.checked === 'true')" class="OTloading">
            <div class="ot-icon-checkbox_selected_disabled" style="margin:1rem"></div>
        </div>
        <div v-else-if="(row.checked === '0' || row.checked === 0 || row.checked === false ||row.checked === 'false')" class="OTloading">
            <div class="ot-icon-checkbox_disabled" style="margin:1rem"></div>
        </div>
        <div v-else class="OTloading">
        </div>
    </b-row>
</template>

<script>
export default {
    props: ['row'],
     created() {
        var that = this;
    },

    methods: {
        checkItem() {
            var that = this;
            this.$emit('checkImportItem', this.row);
        }
    }
}
</script>